import React from 'react'
import BodyText from '../Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group, { GroupGap } from 'components/utils/Group'

interface Props extends React.FieldsetHTMLAttributes<HTMLFieldSetElement> {
  label?: React.ReactNode;
  expanded?: boolean;
  optionGap?: GroupGap;
}

function RadioGroup(props: Props) {
  const { label, expanded, optionGap, children, ...rest } = props

  return (
    <VerticalSpacer {...rest} as="fieldset" gap={16}>
      {label && <BodyText variant="medium" as="legend" weight="bold">{label}</BodyText>}
      <Group direction="vertical" gap={optionGap ?? (expanded ? 16 : 8)}>
        {children}
      </Group>
    </VerticalSpacer>
  )
}

export default RadioGroup
